import { ListingWizardForm } from '@/modules/cars/components/listing/listing-wizard-form'

export function SellerCreateCarPage() {
  return (
    <div className="py-4 space-y-6">
      <h1 className="font-display text-2xl font-bold tracking-tight">Create Vehicle Listing</h1>
      <ListingWizardForm redirectPath="/seller/cars" />
    </div>
  )
}
